import React, { memo } from 'react';
import AIAgentCenterSessionsFilter from './AIAgentCenterSessionsFilter';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import AICallList from './AICallList';
import AIChatList from './AIChatList';

const AIAgentCenterSessions: React.FC = () => {
  const { type } = useAIAgentCenterContext();

  return (
    <div className='flex h-[calc(100vh-178px)] flex-col'>
      <div>
        <AIAgentCenterSessionsFilter />
      </div>
      <div className='flex min-h-0 flex-1'>{type === 'phone' ? <AICallList /> : <AIChatList />}</div>
    </div>
  );
};

export default memo(AIAgentCenterSessions);
